import styled from 'styled-components';
import { Box } from '@mui/system';

interface Props {
  active: number;
  disabled?: number;
}

export const AppointmentWrapper = styled(Box)`
  width: 415px;

  padding: 32px 20px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.color.grey300};
  background: ${({ theme }) => theme.color.white};
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Title = styled('div')`
  width: 100%;
  gap: 8px;

  h6 {
    color: ${({ theme }) => theme.color.grey900};
    font-size: 20px;
    line-height: 28px;
    font-family: 'AcidGrotesk';
    font-weight: 700;
  }

  p {
    color: ${({ theme }) => theme.color.grey700};
    font-size: 18px;
    line-height: 26px;
    font-family: 'AcidGrotesk';
    font-weight: 500;
    letter-spacing: 0.05px;
  }
`;

export const DaySlotWrapper = styled(Box)<Props>`
  display: flex;
  width: 56px;
  padding: 6px;
  align-items: flex-start;
  gap: 4px;
  border-radius: 8px;
  border: 1px solid
    ${({ theme, disabled }) =>
      disabled ? theme.color.grey300 : theme.color.green600};
  background: ${({ theme, active, disabled }) =>
    active
      ? theme.color.green600
      : disabled
      ? theme.color.grey100
      : theme.color.green50};
  color: ${({ theme, active, disabled }) =>
    active
      ? theme.color.white
      : disabled
      ? theme.color.grey400
      : theme.color.grey600};
  font-size: 14px;
  text-align: center;
  font-weight: ${({ active }) => (active ? '700' : '500')};
  line-height: 19.6px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  :hover {
    color: ${({ theme, disabled }) =>
      disabled ? theme.color.grey400 : theme.color.white};
    font-weight: 700;
    background: ${({ theme, disabled }) =>
      disabled ? theme.color.grey100 : theme.color.green600};
  }

  @media screen and (max-width: 900px) {
    width: 53px;
    padding: 8px 4px;
  }
`;

export const TimeSlotWrapper = styled(DaySlotWrapper)<Props>`
  width: calc(25% - 10px);
  justify-content: center;
  padding: 4px 6px;
`;

export const TitleWrapper = styled('span')`
  color: ${({ theme }) => theme.color.grey700};
  font-size: 18px;
  font-weight: 700;
  line-height: 25.2px;
  letter-spacing: 0.045px;
  margin-bottom: 8px;
`;

export const ButtonStyled = styled('button')`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  background-color: transparent;
  border: none;
  box-shadow: none;
  cursor: pointer;

  :hover {
    border-radius: 4px;
    background-color: ${({ theme }) => theme.color.grey100};
    color: ${({ theme }) => theme.color.grey900};
  }

  :disabled {
    opacity: 0.4;
    cursor: not-allowed;
    border-color: ${({ theme }) => theme.color.grey300};
  }

  svg {
    min-width: 24px;
    min-height: 24px;

    path {
      fill: ${({ theme }) => theme.color.grey700};
    }
  }
`;

export const ClinicSlotsWrapper = styled(Box)`
  display: flex;
  margin-top: 8px;
  gap: 12px;
  flex-wrap: wrap;
  position: relative;
  width: 100%;
`;

export const DaySlotList = styled(ClinicSlotsWrapper)`
  gap: 6px;
`;

export const HeaderWrapper = styled(Box)`
  display: flex;
  margin-bottom: 8px;
  justify-content: space-between;
`;

export const PickerStyled = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ButtonWrapper = styled('div')`
  display: flex;
  width: 100%;

  button {
    flex-grow: 1;
    &:last-child {
      margin-left: 20px;
    }
  }
`;

export const StyledSleketon = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0 32px;

  section {
    display: flex;
    flex-direction: column;
    gap: 24px;
    justify-content: space-between;
  }
`;
